import React from 'react';

const PeopleList = props => {
    const { employeeData } = props;
    const employeeOverlay = () => {
        const Photo = value => {
            return value.employee_avatar ? (
                <div className="gallery-icon landscape">
                    <img
                        className="modal__image--circle"
                        draggable="false"
                        width="155"
                        height="155"
                        src={value.employee_avatar.sizes.thumbnail}
                        alt={value.employee_name}
                    />
                </div>
            ) : (
                <div className="people__containerimg">
                    <h3>No photo</h3>
                </div>
            );
        };

        const showEmployee = (value, index) => {
            return (
                value.employee_name &&
                value.employee_lastname && (
                    <div
                        className="people__list--item col col-xs-6 col-sm-4 col-md-3"
                        data-user-id={value.employee_name}
                        key={index}
                        onClick={props.handleClick}>
                        <figure className="gallery-item">
                            {Photo(value)}
                            <figcaption>
                                {value.employee_name &&
                                    value.employee_lastname && (
                                        <strong>
                                            {value.employee_name}{' '}
                                            {value.employee_lastname}
                                        </strong>
                                    )}
                                {value.employee_title && value.employee_title}
                            </figcaption>
                        </figure>
                    </div>
                )
            );
        };

        const showEmployees = employeeData.map((value, index) => {
            return showEmployee(value, index);
        });
        return showEmployees;
    };

    return (
        <div className="people">
            <ul className="people__list">
                <div className="container">
                    <div className="row">
                        {employeeData && employeeOverlay()}
                    </div>
                </div>
            </ul>
        </div>
    );
};

export default PeopleList;



// WEBPACK FOOTER //
// ./src/components/Pages/People/PeopleList.jsx